import React, { useState } from 'react';
import {
  Button,
  Link,
  Modal,
  Text,
  Title
} from '@gjensidige/builders-components';

import { CustomerCareModalProps } from '../interfaces/Types';

export const CustomErrorModal: React.FC<CustomerCareModalProps> = ({
  isOpen,
  onClose
}: CustomerCareModalProps) => {
  const CustomerServiceDetails = () => (
    <div className="customer-service-contact-info-container">
      <Title as="h2" size="5" className="customer-service-box-header">
        Du når oss på
      </Title>
      {/* <Text size="body" className="helper-and-contact-link" dangerouslySetInnerHTML={{ __html: "Telefon: <Link href=\"tel:0104839512\">010-483 95 12</Link>" }} /> */}
      <Text size="body" className="helper-and-contact-link">
        Telefon: <Link href="tel:0104839512">010-483 95 12</Link>
      </Text>
      {/* <Text size="body" className="helper-and-contact-link" dangerouslySetInnerHTML={{ __html: "E-post: <Link href=\"mailto:info@gjensidige.se\">info@gjensidige.se</Link>" }} /> */}
      <Text size="body" className="helper-and-contact-link">
        E-post: <Link href="mailto:info@gjensidige.se">info@gjensidige.se</Link>
      </Text>
    </div>
  );
  return (
    <Modal
      open={isOpen}
      onClick={onClose}
      strict={true}
      closeLabel="calcualtion-modal-close"
      aria-label="calcualtion-modal"
      className="error-helper-modal"
    >
      <Title as="h2" size="4">
        Kontakta oss
      </Title>
      <Text size="body" className="modal-message">
        Om den som ska köra mopeden är mellan 15 och 18 år, kan vi tyvärr inte
        lämna pris via hemsidan. Kontakta oss så hjälper vi dig.
      </Text>
      <div className="customer-care-modal">
        <CustomerServiceDetails />
      </div>
      <div className="footer-btn">
        <Button
          variant="primary"
          className="error-primary-button"
          onClick={onClose}
        >
          Stäng
        </Button>
      </div>
    </Modal>
  );
};
